// extracted by mini-css-extract-plugin
module.exports = {"r0":"CustomerReviews-module--r0--2nVdX","r1":"CustomerReviews-module--r1--2enXp","r2":"CustomerReviews-module--r2--3LQBD"};